window.StockCubeDesktop = {

    schema: {
        ...window.StockCubeCore.schemaBase,
    },

    platformConfig: {
        platform: 'desktop',
        fontSize: 0.022,
        labelYOffset: 0.09,
        usableHeight: 0.8,
        sectorLabelStyle: {
            fontSize: 0.035,
            strokeColor: '#000000',
            outlineWidth: '0%',
            fillOpacity: '1.0',
            zOffset: 0.3,
            yOffset: -0.05,
            margin: 0.2,
            circleRadius: 0.012,
            localYOffset: 0.05,
            localZOffset: 0.05,
        },
        primaryLabelStyle: {
            themeAware: true,
            depthOffset: '0',
            outlineWidth: '0.005',
            outlineBlur: '0.01',
            outlineOpacity: '0.7',
            strokeWidth: '0',
            fillOpacity: '1.0',
        },
    },

    beforeInit: async function () {
        this.barYOffset = 0.01;
        this.sectorPlatformOffset = 0.025;
        this.minSectorWidth3D = 100;
        this.originalContainerY = null;
        this.viewportAdjustmentApplied = false;

        if (this.data.dataSource === 'top-dollar-vol' || this.data.dataSource === 'top-dollar-vol-sec') {
            setTimeout(() => {
                const wrapper = this.el.parentElement;
                if (wrapper && wrapper.id === 'stock-3d-cube-wrapper') {
                    wrapper.setAttribute('position', '0 0.250 .5');
                    if (wrapper.object3D) {
                        wrapper.object3D.position.set(0, 0.250, 0.5);
                    }
                    if (__LOG_INFO__) AppLog.info('[stock-cube-visualizer init] Set wrapper position for top-dollar-vol/top-dollar-vol-sec to 0 0.250 .5');
                } else {
                    const wrapperById = document.querySelector('#stock-3d-cube-wrapper');
                    if (wrapperById) {
                        wrapperById.setAttribute('position', '0 0.250 .5');
                        if (wrapperById.object3D) {
                            wrapperById.object3D.position.set(0, 0.250, 0.5);
                        }
                    }
                }
            }, 100);
        }

        let initialMinPrice = 1;
        let initialMinCap = 10_000_000_000;
        const minPriceInput = document.getElementById('sip-minprice');
        const minCapInput = document.getElementById('sip-mincap');
        if (minPriceInput && minCapInput) {
            initialMinPrice = Number(minPriceInput.value || 1);
            initialMinCap = Number(minCapInput.value || 10_000_000_000);
        }
        this.sipFilters = { minPrice: initialMinPrice, minCap: initialMinCap };
    },

    afterInit: function () {
        this._isLightTheme = document.body.classList.contains('light') || document.body.classList.contains('cb-light');
        const bloomComp = this.el.sceneEl && this.el.sceneEl.components && this.el.sceneEl.components['bloom'];
        this._bloomBaseStrength = (bloomComp && bloomComp.data) ? bloomComp.data.strength : 0.2;
        this.setupThemeListener();
        this._applyBloomForTheme(this._isLightTheme);
        this.updateLabelsGlowState();
    },

    _applyBloomForTheme: function (isLight) {
        const scene = this.el.sceneEl;
        if (!scene || !scene.hasAttribute('bloom')) return;
        scene.setAttribute('bloom', 'strength', isLight ? this._bloomBaseStrength : this._bloomBaseStrength * 0.4);
    },

    setupThemeListener: function () {
        try {
            this._onThemeChanged = (e) => {
                if (!e || !e.detail) return;
                const newTheme = e.detail.themeMode;
                if (newTheme) {
                    const isLight = newTheme === 'Light';
                    this.updateLabelsTheme(isLight);
                }
            };
            this.el.sceneEl.addEventListener('theme-changed', this._onThemeChanged);

            this._themeObserver = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    if (mutation.attributeName === 'class') {
                        const isLight = document.body.classList.contains('light') || document.body.classList.contains('cb-light');
                        this.updateLabelsTheme(isLight);
                    }
                }
            });
            this._themeObserver.observe(document.body, { attributes: true });

        } catch (err) {
            if (__LOG_WARN__) AppLog.warn('[Stock Visualizer] Failed to attach theme listener', err);
        }
    },

    updateLabelsTheme: function (isLight) {
        this._isLightTheme = isLight;
        this._applyBloomForTheme(isLight);
        if (this.emissivePulse && this.emissivePulse.bars && this.emissivePulse.bars.size > 0) {
            const baseC = new THREE.Color(isLight ? '#111827' : '#FFFFFF');
            this.emissivePulse.bars.forEach((info) => {
                if (info.labelBaseRGB) {
                    info.labelBaseRGB[0] = baseC.r;
                    info.labelBaseRGB[1] = baseC.g;
                    info.labelBaseRGB[2] = baseC.b;
                }
                info.isLightTheme = isLight;
            });
        }
        if (!this.stockBars) return;

        const labelColor = isLight ? "#111827" : "#FFFFFF";
        const outlineColor = isLight ? "#FFFFFF" : "#000000";

        if (this.data && this.data.dataSource === 'mmap'
                && window.MarketMapSharedRendering
                && typeof window.MarketMapSharedRendering.updateMmapDesktopTheme === 'function') {
            window.MarketMapSharedRendering.updateMmapDesktopTheme(this, isLight);
        }

        const isGlowOn = !!this.getConfigSetting('isGlowOn', false) && this.getQualityLevel() === 'quality';
        const strokeColor = isGlowOn ? labelColor : outlineColor;

        for (const [ticker, barInfo] of this.stockBars) {
            if (barInfo && barInfo.primaryLabel) {
                const label = barInfo.primaryLabel;

                label.setAttribute('color', labelColor);
                label.setAttribute('outline-color', outlineColor);

                if (label.hasAttribute('stroke-color')) {
                    label.setAttribute('stroke-color', strokeColor);
                }
            }
        }

        if (this.sectorLabels) {
            for (const [sectorId, labelGroup] of this.sectorLabels) {
                const textEl = labelGroup.querySelector('a-troika-text');
                if (textEl) {
                    textEl.setAttribute('color', labelColor);
                    textEl.setAttribute('outline-color', outlineColor);
                }
            }
        }
        this.updateLabelsGlowState();
    },

    updateLabelsGlowState: function () {
        if (this.platformConfig.platform !== 'desktop') return;
        if (!this.stockBars) return;

        const isGlowOn = !!this.getConfigSetting('isGlowOn', false) && this.getQualityLevel() === 'quality';
        const isLight = document.body.classList.contains('light') || document.body.classList.contains('cb-light');
        const labelColor = isLight ? "#111827" : "#FFFFFF";
        const outlineColor = isLight ? "#FFFFFF" : "#000000";

        const outlineOpacity = isGlowOn ? '0.9' : '0.7';
        const outlineWidth = isGlowOn ? '0.008' : '0.005';
        const strokeWidth = isGlowOn ? '6%' : '0';
        const strokeColor = isGlowOn ? labelColor : outlineColor;

        for (const [ticker, barInfo] of this.stockBars) {
            if (barInfo && barInfo.primaryLabel) {
                const label = barInfo.primaryLabel;
                label.setAttribute('outline-opacity', outlineOpacity);
                label.setAttribute('outline-width', outlineWidth);
                label.setAttribute('stroke-width', strokeWidth);
                label.setAttribute('stroke-color', strokeColor);
            }
        }

        const sectorOutlineWidth = isGlowOn ? '12%' : '0%';
        if (this.sectorLabels) {
            for (const [sectorId, labelGroup] of this.sectorLabels) {
                const textEl = labelGroup.querySelector('a-troika-text');
                if (textEl) {
                    textEl.setAttribute('outline-width', sectorOutlineWidth);
                    textEl.setAttribute('outline-color', outlineColor);
                }
            }
        }
    },

    calculateViewportHeight: function (fov, distance) {
        const fovRad = (fov * Math.PI) / 180;
        const height = 2 * Math.tan(fovRad / 2) * distance;
        return height;
    },

    adjustChartToFitViewport: function (stockBars, heightScale, maxHeightValue, targetHeight, zeroPlane, container) {
        if (!stockBars || stockBars.size === 0 || !container || !container.object3D) {
            if (__LOG_WARN__) AppLog.warn('[chart viewport] adjustChartToFitViewport - No stock bars or container, returning');
            return;
        }

        const containerPos = container.getAttribute('position') || { x: 0, y: 0, z: 0.5 };
        const containerX = typeof containerPos === 'string'
            ? parseFloat(containerPos.split(' ')[0])
            : (containerPos.x || 0);
        const containerZ = typeof containerPos === 'string'
            ? parseFloat(containerPos.split(' ')[2])
            : (containerPos.z || 0.5);

        container.object3D.updateMatrixWorld(true);
        const bbox = new THREE.Box3().setFromObject(container.object3D);

        const size = new THREE.Vector3();
        bbox.getSize(size);

        const camera = document.getElementById('camera');
        if (!camera) {
            if (__LOG_WARN__) AppLog.warn('[chart viewport] Camera not found');
            return;
        }

        camera.object3D.updateMatrixWorld(true);
        if (container.object3D.parent) {
            container.object3D.parent.updateMatrixWorld(true);
        }

        const cameraWorldPos = new THREE.Vector3();
        camera.object3D.getWorldPosition(cameraWorldPos);

        let localCameraY = cameraWorldPos.y;
        if (container.object3D.parent) {
            const localCameraPos = container.object3D.parent.worldToLocal(cameraWorldPos.clone());
            localCameraY = localCameraPos.y;
        }

        let maxHeightUp = 0;
        let maxHeightDown = 0;

        if (this.heightValueFn) {
            const globalData = this._cachedGlobalMax || this.calculateGlobalMaxHeightValue(this.heightValueFn);
            if (globalData.maxPos > 0) {
                maxHeightUp = Math.abs(this.calculateBarHeight(globalData.maxPos, heightScale, maxHeightValue, targetHeight));
            }
            if (globalData.maxNeg > 0) {
                maxHeightDown = Math.abs(this.calculateBarHeight(-globalData.maxNeg, heightScale, maxHeightValue, targetHeight));
            }
        }

        let hasPositive = maxHeightUp > 0;
        let hasNegative = maxHeightDown > 0;
        if (['top-gainers', 'top-gainers-sec'].includes(this.data.dataSource)) {
            hasPositive = true;
            hasNegative = false;
        }
        if (['top-losers', 'top-losers-sec'].includes(this.data.dataSource)) {
            hasPositive = false;
            hasNegative = true;
        }

        const isBidirectional = hasPositive && hasNegative;

        let targetY = 0;

        if (isBidirectional) {
            targetY = localCameraY - zeroPlane;
        } else if (hasPositive) {
            targetY = localCameraY - zeroPlane - (maxHeightUp / 2);
        } else if (hasNegative) {
            targetY = localCameraY - zeroPlane + (maxHeightDown / 2);
        } else {
            targetY = localCameraY - zeroPlane;
        }

        const doNotRaise = ['mmap', 'top-losers', 'top-losers-sec'];
        if (!doNotRaise.includes(this.data.dataSource)) {
            targetY += 0.1;
        }

        if (this.data.dataSource === 'watchlist-reports') {
            targetY = 0;
        }

        container.setAttribute('position', `${containerX} ${targetY} ${containerZ}`);
        if (container.object3D) {
            container.object3D.position.set(containerX, targetY, containerZ);
        }
        const camComponent = camera.getObject3D('camera') || (camera.components && camera.components.camera && camera.components.camera.camera);
        if (camComponent && size.x > 0) {
            const vFovRad = THREE.MathUtils.degToRad(camComponent.fov);
            const aspect = camComponent.aspect || (window.innerWidth / window.innerHeight);
            const hFovRad = 2 * Math.atan(Math.tan(vFovRad / 2) * aspect);

            const targetWidth = size.x / 2;

            const mmapProximityFactor = (this.data && this.data.dataSource === 'mmap') ? 0.89 : 1.0;
            const requiredDistance = ((targetWidth / 2) / Math.tan(hFovRad / 2)) * 1.20 * mmapProximityFactor;

            let bboxMaxZ = bbox.max.z;
            if (this.data && this.data.dataSource === 'mmap') {
                const wrapperWorldPos = new THREE.Vector3();
                container.object3D.getWorldPosition(wrapperWorldPos);
                bboxMaxZ = wrapperWorldPos.z;
            }
            const targetWorldZ = bboxMaxZ + requiredDistance;

            const targetWorldPos = new THREE.Vector3();
            camera.object3D.getWorldPosition(targetWorldPos);
            targetWorldPos.z = targetWorldZ;

            let localTargetZ = targetWorldZ;
            if (camera.object3D.parent) {
                const localPos = camera.object3D.parent.worldToLocal(targetWorldPos.clone());
                localTargetZ = localPos.z;
            }

            const currentCamPos = camera.getAttribute('position') || { x: 0, y: 2.75, z: 2 };
            const cx = typeof currentCamPos === 'string' ? parseFloat(currentCamPos.split(' ')[0]) : (currentCamPos.x || 0);
            const cy = typeof currentCamPos === 'string' ? parseFloat(currentCamPos.split(' ')[1]) : (currentCamPos.y || 2.75);
            const cz = typeof currentCamPos === 'string' ? parseFloat(currentCamPos.split(' ')[2]) : (currentCamPos.z || 2);

            const finalZ = (!window.hasPerformedInitialZoomFit) ? localTargetZ : cz;

            camera.setAttribute('position', `${cx} ${cy} ${finalZ.toFixed(3)}`);
            if (camera.object3D) {
                camera.object3D.position.set(cx, cy, finalZ);
            }

            window.hasPerformedInitialZoomFit = true;
        } else {
            if (__LOG_WARN__) AppLog.warn('[chart viewport] Z camera adjustment failed: camera component not found or chart size X is 0.');
        }

        this.viewportAdjustmentApplied = true;
    },

};

AFRAME.registerComponent('stock-cube-visualizer', {
    ...window.StockCubeCore,
    ...window.MarketMapVisualizer,
    ...window.MarketMapLayout,
    ...window.StockCubeDesktop,
});
